<app-non-supported-groups *ngIf="(groupSupported$ | async) === false" [supportedGroups]="supportedGroups"></app-non-supported-groups>

<mat-drawer-container *ngIf="groupSupported$ | async" [hasBackdrop]="false">
  <mat-drawer #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" position="start" [opened]="opened" (openedStart)="opened = true" (closedStart)="opened = false">
    <div class="drawer-lining">
      <div class="close-wrapper">
        <h2>Filters</h2>
        <button mat-icon-button class="close-button" (click)="sidenav.close()"><mat-icon>close</mat-icon></button>
      </div>
      <mat-divider></mat-divider>

      <h3>Ad Details</h3>

      <mat-form-field *ngIf="(currentAccountGroup$ | async) === 'merchants'">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="controls.status" #adMerchantStatus>
          <mat-option value="all">All</mat-option>
          <mat-option value="active">Active</mat-option>
          <mat-option value="staged">Staged</mat-option>
          <mat-option value="expiring_soon">Expiring Soon</mat-option>
          <mat-option value="expired">Archived</mat-option>
        </mat-select>
        <mat-hint *ngIf="adMerchantStatus.value === 'staged'">New ads scheduled to start in the future</mat-hint>
        <mat-hint *ngIf="adMerchantStatus.value === 'expiring_soon'">Ending in the next seven days</mat-hint>
      </mat-form-field>

      <mat-form-field *ngIf="(currentAccountGroup$ | async) === 'affiliates'" floatLabel="always" class="merchants-filter-form-field">
        <mat-label>Merchants</mat-label>
        <input matInput placeholder="Merchant Name, URL, Classic ID" [matAutocomplete]="merchantAutoComplete" [formControl]="controls.merchant" #merchantsInput spellcheck="false">
        <mat-error>{{controls.merchant.errors | validationMessage}}</mat-error>
        <mat-autocomplete #merchantAutoComplete="matAutocomplete" [displayWith]="merchantFilterDisplayWith"
                          (optionSelected)="merchantFilterAutoCompleteOnSelected($event, merchantsInput)" (opened)="autoSelectOnOpened(controls.merchant)" (closed)="merchantFilterAutoCompleteOnClosed()">
          <mat-option [value]="allMerchants" class="autocomplete-option">
            <p class="mat-subtitle-2">All Merchants</p>
          </mat-option>
          <mat-option *ngFor="let merchant of merchantFilteredOptionsLimited$ | async" [value]="merchant" class="autocomplete-option">
            <div class="mat-subtitle-2">{{merchant.merchant_name}}</div>
            <div class="mat-body-2">{{merchant.merchantWebsiteUrlStripped}}</div>
            <span class="circle" [ngClass]="merchant.merchant_status === 'active' && merchant.relationship_status === 'active' ? 'circle-green' : 'circle-red'">&nbsp;</span><span><mat-icon [svgIcon]="merchant.merchant_network"></mat-icon></span><span class="classic-id mat-caption">{{merchant.classic_merchant_id}}</span>
          </mat-option>
          <mat-option *ngIf="(merchantFilteredOptions$ | async)?.length > filteredLimit" [disabled]="true" class="autocomplete-option">
            <p class="mat-subtitle-2">Results limited. Filter to see more results.</p>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Ad Type</mat-label>
        <mat-select [formControl]="controls.adType">
          <mat-option value="all">All</mat-option>
          <mat-option value="banner">Banner</mat-option>
          <mat-option value="text">Text</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="image-dimensions">
        <mat-form-field>
          <mat-label>Banner Width</mat-label>
          <input type="number" [formControl]="controls.imageWidth" matInput placeholder="e.g. 300">
          <mat-error></mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Banner Height</mat-label>
          <input type="number" [formControl]="controls.imageHeight" matInput placeholder="e.g. 250">
          <mat-error></mat-error>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Ad Name</mat-label>
        <input [formControl]="controls.adTitle" matInput placeholder="Search">
        <mat-error></mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Ad Id</mat-label>
        <input [formControl]="controls.classicMerchantAdId" type="number" matInput placeholder="Search">
        <mat-error></mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Ad Label</mat-label>
        <mat-select [formControl]="controls.dynamicLabel" #adLabelSelect (click)="triggerAnalytics('AdManagement_AdLabel_filter', 'AdManagement');">
          <mat-option value="all">All</mat-option>
          <mat-option value="new">New</mat-option>
          <mat-option value="dynamic">Dynamic</mat-option>
          <mat-option value="designated">Designated</mat-option>
        </mat-select>
        <mat-hint *ngIf="adLabelSelect.value === 'new'">Modified in last seven days</mat-hint>
        <mat-hint *ngIf="adLabelSelect.value === 'dynamic'">Scheduled to update</mat-hint>
        <mat-hint *ngIf="adLabelSelect.value === 'designated'">Available for select affiliates</mat-hint>
      </mat-form-field>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <mat-card appearance="raised"
              class="top-card"
              [style.margin-left]="opened ? '2%' : '5%'" [style.margin-right]="opened ? '2%' : '5%'">
      <div>
        <mat-card-title>Ad Management</mat-card-title>
        @if ((currentAccountGroup$| async) === 'merchants') {
          <mat-card-subtitle>Manage the ads that are available to your affiliate partners.</mat-card-subtitle>
        }
        @if ((currentAccountGroup$| async) === 'affiliates') {
          <mat-card-subtitle>Merchant provided banner and text ads.</mat-card-subtitle>
        }
      </div>
      @if ((currentAccountGroup$ | async) === 'merchants') {
        <button mat-raised-button color="primary"
                (click)="openCreateAdDialog(); triggerAnalytics('AdManagement_CreateAd_button', 'AdManagement');">Create
          Ad
        </button>
      }
    </mat-card>
    <mat-card appearance="raised" [style.margin-left]="opened ? '2%' : '5%'" [style.margin-right]="opened ? '2%' : '5%'" >
      <div>
        @if((currentAccountGroup$ | async) === 'merchants') {
          <mat-checkbox
            (change)="onMasterToggleChange($event)"
            [indeterminate]="masterToggleState() === 'indeterminate'"
            [checked]="masterToggleState() === 'checked'">
          </mat-checkbox>
        }
        <button mat-icon-button matTooltip="Toggle Filter" style="vertical-align: middle;" (click)="sidenav.toggle()"><mat-icon color="accent">filter_list</mat-icon></button>
        @if((currentAccountGroup$ | async) === 'merchants') {
          <button mat-icon-button matTooltip="Download Ads" style="vertical-align: middle;" (click)="downloadMerchantAds()"><mat-icon color="accent">download</mat-icon></button>
        }
      </div>
      <mat-chip-listbox>
        @for (chip of filterChips(); track chip.displayTitle) {
          <mat-chip class="blue" (removed)="removeChip(chip)">{{chip.displayTitle}} = {{(chip.value | titleCase)}}
            <button matChipRemove [attr.aria-label]="'remove ' + chip.displayTitle + ' ' + chip.value">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </mat-chip-listbox>
      <app-merchant-ads [filterMap]="filterMap()"
                        [masterToggleChecked]="masterToggleChecked()"
                        (selectionChange)="merchantAdsSelected$.next($event)"
                        (requestParamsChange)="requestParamChange($event)"
                        (masterToggleState)="onMasterToggleStateOutput($event)"></app-merchant-ads>
    </mat-card>
  </mat-drawer-content>
</mat-drawer-container>
